/**
 * @file useIsCompactLayout.ts
 * @description Хук компактного layout без MUI (phase08.5 shadcn).
 *
 * Возвращает true когда:
 *  - ширина < 768px (Tailwind md breakpoint), либо
 *  - landscape + height ≤ 500px (landscape-телефон).
 */

import { useEffect, useState } from "react";

function evaluate(): boolean {
  if (typeof window === "undefined") return false;
  const narrow = window.matchMedia("(max-width: 767.98px)").matches;
  const shortLandscape = window.matchMedia(
    "(orientation: landscape) and (max-height: 500px)",
  ).matches;
  return narrow || shortLandscape;
}

export function useIsCompactLayout(): boolean {
  const [isCompact, setIsCompact] = useState(evaluate);

  useEffect(() => {
    function update() {
      setIsCompact(evaluate());
    }
    const mq1 = window.matchMedia("(max-width: 767.98px)");
    const mq2 = window.matchMedia(
      "(orientation: landscape) and (max-height: 500px)",
    );
    mq1.addEventListener("change", update);
    mq2.addEventListener("change", update);
    return () => {
      mq1.removeEventListener("change", update);
      mq2.removeEventListener("change", update);
    };
  }, []);

  return isCompact;
}
